import { createContext, useMemo, useState } from "react";


export const deliveryProviderContext = createContext([])

export const DeliveryProvider = ({children}) => {
    const [listInProgressOrder, setListInProgressOrder] = useState([])

    const contextValue = useMemo(() => ({
        listInProgressOrder,
        setListInProgressOrder
    }), [listInProgressOrder, setListInProgressOrder])

    return(
        <deliveryProviderContext.Provider value={contextValue}> 
            {children}
        </deliveryProviderContext.Provider>
    )

}